import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './design-system/gb-variables.css';
import AWLandingPage from './pages/aw/AWLandingPage';
import { ShopMaintenance } from './pages/aw/shop/ShopMaintenance';
import { LanguageProvider } from './i18n';

const App: React.FC = () => {
    React.useEffect(() => {
        document.documentElement.setAttribute('data-theme', 'dark');
    }, []);

    return (
        <LanguageProvider>
            <Router>
                <Routes>
                    <Route path="/aw/shop" element={<ShopMaintenance />} />
                    <Route path="/aw/*" element={<AWLandingPage />} />
                    <Route path="/" element={<Navigate to="/aw" replace />} />
                </Routes>
            </Router>
        </LanguageProvider>
    );
};

export default App;
